import { render, staticRenderFns } from "./DealStatisticsCard.vue?vue&type=template&id=a4b79946&"
import script from "./DealStatisticsCard.vue?vue&type=script&lang=ts&"
export * from "./DealStatisticsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports